

export const SuccessMessage = ({text}) => <div className='success-system-message'> {text}</div>

export const ErrorMessage = ({text}) => <div className='error-system-message'> {text} </div>
